import { UPDATE_USER_START, UPDATE_USER_SUCCESS, UPDATE_USER_FAIL } from '../actions/ActionsTypes';

const initialState = {
    success: false,
    error: null,
    loading: false,
};


export default function (state = initialState, action) {
    switch (action.type) {
        case UPDATE_USER_START:
            return {
                ...state,
                loading: true,
                error: false
            }
        case UPDATE_USER_SUCCESS:
            return {
                ...state,
                success: true,
                error: null,
                loading: false
            }
        case UPDATE_USER_FAIL:
            return {
                ...state,
                success: false,
                error: true,
                loading: false,
            }
        default:
            return state;
    }
}